import { Role } from '@/api/RoleApi';
import { Province } from './types';
import { Company } from '@/api/CompanyApi';
import { BaseEntity } from '@/api/EntityApi';

export enum UserStatus {
	INACTIVE = 'inactive',
	ACTIVE = 'active',
	SUSPENDED = 'suspended',
}

export enum UserType {
	CLIENT = 'client',
	ADMIN = 'admin',
	MERCHANT = 'merchant',
}

interface BaseUser extends BaseEntity {
	firstName: string;
	lastName: string;
	email: string;
	password: string;
	status: UserStatus;
	userType: UserType;
}

export interface Admin extends BaseUser {
	role: Role;
	userType: UserType.ADMIN;
	lastName: string;
}

export interface Client extends BaseUser {
	phoneNumber: string;
	company: Company;
	discount: number;
	canAddClients: boolean;
	provinces: Province[];
	userType: UserType.CLIENT;
}

export interface Merchant extends BaseUser {
	phoneNumber: string;
	provinces: Province[];
	userType: UserType.MERCHANT;
}

export type AppUser = Admin;
